<script>

export default {
  name: 'TableHeader',
  props: {
    title: {
      type: String,
    }
  },
};
</script>

<template>
    <div class="table-header">
        <div class="content">
            <slot>
                {{ title }}
            </slot>
        </div>

        <div class="divider"></div>
    </div>
</template>

<style scoped lang="scss">
.table-header {
    /* Card header */

    /* Auto layout */
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 0;
    isolation: isolate;

    /* Base / White */
    background: #FFFFFF;

    /* Inside auto layout */
    flex: none;
    order: 0;
    align-self: stretch;
    flex-grow: 0;

    .content {
        /* Content */

        /* Auto layout */
        display: flex;
        flex-direction: row;
        //align-items: flex-start;
        align-items: center;
        padding: 20px 24px;
        gap: 16px;

        /*width: 1242px;*/
        width: 100%;
        height: 68px;

        /* Inside auto layout */
        flex: none;
        order: 0;
        align-self: stretch;
        flex-grow: 0;
        z-index: 1;

        /* Text-xl/Semi Bold */
        font-family: Geist, sans-serif;
        font-style: normal;
        font-weight: 600;
        font-size: 20px;
        line-height: 28px;
        /* identical to box height, or 140% */

        /* Gray/900 */
        color: #181D27;

        /* Inside auto layout */
        flex: none;
        flex-grow: 0;
    }
    .divider {
        /* Divider */

        width: 100%;
        height: 1px;

        /* Gray/200 */
        background: #E9EAEB;

        /* Inside auto layout */
        flex: none;
        order: 1;
        align-self: stretch;
        flex-grow: 0;
        z-index: 0;

    }
}

</style>
